document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('variant-selects').forEach(function (wrapper) {
    var form = document.getElementById(wrapper.closest('[id^="MainProduct"]')?.querySelector('form')?.id || '');
    var submitButton = document.querySelector('#' + wrapper.getAttribute('data-section') + ' [name="add"]') 
      || document.querySelector('form[id*="product-form"] [name="add"]');

    wrapper.addEventListener('change', function () {
      var scriptTag = wrapper.querySelector('[data-selected-variant]');
      if (!scriptTag) return;
      try {
        var variant = JSON.parse(scriptTag.textContent);
        if (!variant || !submitButton) return;
        var priceFormatted = (variant.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        });
        var span = submitButton.querySelector('span');
        if (span) {
          span.textContent = variant.available
            ? 'Add to cart — ' + priceFormatted
            : 'Sold out';
        }
      } catch (e) {}
    });
  });
});